import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import AutoComplete from 'material-ui/AutoComplete';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

function getSource(array, field) {
    return Array.from(new Set(array.map(item => item[field])));
}

function getDefault(array, field) {
    const firstNotEmpty = array.find(item => !!item[field]);

    return firstNotEmpty ? firstNotEmpty[field] : '';
}

class MergeDialog extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        participants: PropTypes.array,
        onSave: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    };

    state = {
        name: '',
        email: '',
        grade: '',
        gender: '',
        school: '',
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.participants && nextProps.participants !== this.props.participants) {
            this.setState({
                nameSource: getSource(nextProps.participants, 'name'),
                emailSource: getSource(nextProps.participants, 'email'),
                schoolSource: getSource(nextProps.participants, 'school'),
                gradeSource: getSource(nextProps.participants, 'grade'),

                name: getDefault(nextProps.participants, 'name'),
                email: getDefault(nextProps.participants, 'email'),
                school: getDefault(nextProps.participants, 'school'),
                grade: getDefault(nextProps.participants, 'grade'),
                gender: ['f', 'ж'].includes((getDefault(nextProps.participants, 'gender') || '').toLowerCase())
                    ? 'f'
                    : 'm',
            });
        }
    }

    handleNameChange = name => this.setState({ name });
    handleEmailChange = email => this.setState({ email });
    handleSchoolChange = school => this.setState({ school });
    handleGenderChange = (e, key, gender) => this.setState({ gender });
    handleGradeChange = grade => {
        grade = grade.replace(/\D/g, '');

        if (grade !== '') {
            grade = parseInt(grade, 10);
        }

        this.setState({ grade });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    handleSave = () => {
        const {
            intl: { formatMessage },
        } = this.props;
        const { name, email, grade, gender, school } = this.state;

        this.props.onSave({ name, email, grade, gender: formatMessage({ id: 'EnterData.gender.' + gender }), school });
    };

    render() {
        const {
            open,
            intl: { formatMessage },
            participants,
        } = this.props;
        const { name, email, grade, gender, school, nameSource, emailSource, schoolSource, gradeSource } = this.state;

        const actions = [
            <FlatButton
                label={formatMessage({ id: 'MergeDialog.cancel' })}
                primary={true}
                onClick={this.handleCancel}
            />,
            <FlatButton label={formatMessage({ id: 'MergeDialog.merge' })} primary={true} onClick={this.handleSave} />,
        ];

        if (!participants) {
            return null;
        }

        return (
            <Dialog title={formatMessage({ id: 'MergeDialog.title' })} actions={actions} modal={true} open={open}>
                <AutoComplete
                    searchText={name}
                    dataSource={nameSource}
                    filter={AutoComplete.noFilter}
                    onUpdateInput={this.handleNameChange}
                    floatingLabelText={formatMessage({ id: 'EnterData.name' })}
                    openOnFocus
                    fullWidth
                />
                <SelectField
                    floatingLabelText={formatMessage({ id: 'EnterData.gender' })}
                    value={gender}
                    onChange={this.handleGenderChange}
                    fullWidth
                >
                    <MenuItem value="m" primaryText="м" />
                    <MenuItem value="f" primaryText="ж" />
                </SelectField>
                <AutoComplete
                    searchText={grade}
                    dataSource={gradeSource}
                    filter={AutoComplete.noFilter}
                    onUpdateInput={this.handleGradeChange}
                    floatingLabelText={formatMessage({ id: 'EnterData.grade' })}
                    openOnFocus
                    fullWidth
                />
                <AutoComplete
                    searchText={school}
                    dataSource={schoolSource}
                    filter={AutoComplete.noFilter}
                    onUpdateInput={this.handleSchoolChange}
                    floatingLabelText={formatMessage({ id: 'EnterData.school' })}
                    openOnFocus
                    fullWidth
                />
                <AutoComplete
                    searchText={email}
                    dataSource={emailSource}
                    filter={AutoComplete.noFilter}
                    onUpdateInput={this.handleEmailChange}
                    floatingLabelText={formatMessage({ id: 'EnterData.email' })}
                    openOnFocus
                    fullWidth
                />
            </Dialog>
        );
    }
}

export default injectIntl(MergeDialog);



// WEBPACK FOOTER //
// ./src/Components/ParticipantsTable/MergeDialog.js